var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageView',{attrs:{"title":"专家年度评价登记"}},[_c('template',{slot:"action"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.add}},[_vm._v("保存")])],1),_c('ExpertYearAssessForm',{ref:"accidentForm"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }